import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CollectionSummaryReport } from './Pages';

export const CollectionSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CollectionSummaryReport} />
       
    </Fragment>
)